
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Candle } from 'components/Candle'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Le 5 mars 2020, une femme âgée de 74 ans décède au CHUV (Centre hospitalier
  universitaire vaudois), à Lausanne. C’est la première victime du Covid-19 en
  Suisse.
    </p>
    <div className='centered'>
  <div className='candlewrapper'>
    <Candle sex='f' pos={10} className='marked' mdxType="Candle" />
  </div>
    </div>
    <p>
  Trois jours plus tard, un homme (76 ans) est terrassé par ce même virus dans
  le canton de Bâle-Campagne. Dans la même semaine, une troisième personne (80
  ans) meurt pour les mêmes raisons dans la région de Mendrisio (TI).
    </p>
    <div className='centered'>
  <div className='candlewrapper'>
    <Candle sex='m' pos={10} className='marked' mdxType="Candle" />
    <Candle sex='m' pos={10} className='marked' mdxType="Candle" />
  </div>
    </div>
    <p>
  Il y a un an, presque jour pour jour, ces trois premiers décès ont fait la une
  des journaux du pays. Les Suisses découvraient alors que la pandémie pouvait
  être mortelle. Ils ont appris, depuis, à vivre avec cette triste réalité.
  Depuis le mois de mars 2020, jusqu’à 100 personnes par jour sont décédées
  après avoir été infectées par le coronavirus. Toutes les catégories de la
  population ont été touchées, celle des plus de 70 ans représentant toutefois
  90% des victimes. Le nombre de décès a été beaucoup plus important durant la
  deuxième vague que lors de la première.
    </p>
    <p>
  Nous avons voulu rendre hommage à ces femmes et ces hommes. Chaque bougie,
  ci-dessous, représente un défunt. Les rouges pour les femmes, les bleues pour
  les hommes. Les cas sont présentés de manière chronologique, regroupés par
  semaine. Nous sommes parvenus parfois à leur donner un nom. Dans plusieurs
  cas, nous avons pu raconter leur histoire de vie, comment ils ont affronté la
  maladie. Le récit a été fait avec l’accord de leurs proches qui ont désiré
  témoigner du drame qu’ils ont vécu. Les familles sont des victimes
  collatérales de cette pandémie.
    </p>
    <p>
  Ce travail a été publié pour la première fois sur ce site en décembre 2020,
  lorsque la Suisse avait atteint le cap des 5000 morts du Covid-19. Depuis, le
  nombre de décès n’a cessé d’augmenter. Il a atteint le 2 mars 2021, selon les
  statistiques officielles livrées par les cantons, le seuil des 10’000 morts.
  Aucun d’entre eux ne doit être oublié.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;